import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=8a90fce4"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=8a90fce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports